import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { PageSource } from "../types/tracking";
import useNavigation from "./navigation";
import useAccount, { accountQueryKey } from "./useAccount";
import { AccountData } from "./useAccountTypes";
import { userNameSchema } from "./useUpdateName";

export const useLoginRedirect = () => {
  const navigation = useNavigation();
  const queryClient = useQueryClient();

  useAccount();

  return useCallback(async () => {
    try {
      const accountData = await queryClient.ensureQueryData<AccountData>({
        queryKey: accountQueryKey,
      });

      const hasValidName =
        Boolean(accountData.name) && userNameSchema.safeParse(accountData?.name).success;
      if (!hasValidName) {
        navigation.goToUpdateNamePage();
        return;
      }
    } catch (err) {
      // Ignore the error here proceed with the redirection
    }
    const isRedirecting = navigation.tryRedirectFromSearchParams(PageSource.Signin);
    if (isRedirecting) {
      return;
    }
    navigation.goToProfile();
  }, [navigation, queryClient]);
};
